import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { ACCOUNTS_ERROR, CREATE_ACCOUNT, CREATING_ACCOUNT, DELETE_ACCOUNT, DELETING_ACCOUNT, GET_ACCOUNTS, GETTING_ACCOUNTS } from "../types"


export const createAccount = (payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_ACCOUNT,
            payload: true
        })

        const response = await axios.post(`${baseUrl}/bank-accounts`, payload, { headers })
        
        dispatch({
            type: CREATE_ACCOUNT,
            payload: response.data.data
        })
    }
    catch(error){
        dispatch({
            type: ACCOUNTS_ERROR,
            error
        })
    }
}

export const deleteAccount = (id) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: DELETING_ACCOUNT,
            payload: true
        })

        const response = await axios.delete(`${baseUrl}/bank-accounts/${id}`, { headers })
        
        dispatch({
            type: DELETE_ACCOUNT,
            payload: response.data.data
        })
    }
    catch(error){
        dispatch({
            type: ACCOUNTS_ERROR,
            error
        })
    }
}

export const fetchAccounts = (filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/bank-accounts?expand=createdBy`
        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_ACCOUNTS,
            payload: true
        })

        const response = await axios.get(url, { headers })
        // console.log(response.data.data)
        dispatch({
            type: GET_ACCOUNTS,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: ACCOUNTS_ERROR,
            error
        })
    }
}

export const clearCreatedAccount = () => async (dispatch) => {    
    try{

        dispatch({
            type: CREATE_ACCOUNT,
            payload: null
        })
        
    }
    catch(error){
        dispatch( {
            type: ACCOUNTS_ERROR,
            error
        })
    }
}

export const clearDeletedDownloadable = () => async (dispatch) => {    
    try{

        dispatch({
            type: DELETE_ACCOUNT,
            payload: null
        })
        
    }
    catch(error){
        dispatch( {
            type: ACCOUNTS_ERROR,
            error
        })
    }
}